import CookieManager from "../Utils/CookieManager";
import { REPEAT_USER_COOKIE_NAME, SELLER_STATE_COOKIE, EVALUATION_STATES, USER_VISIT_STATUS, FLOW_TYPES } from "../Constants/evaluation";
import { UNKNOWN } from "../Constants/locations";
import UserSession from "../Utils/UserSession";
import DependencyManager from "../DependencyManager";
import LocalStorageHelper from "../Utils/LocalStorageHelper";
import { getAcquisitionChannelTrackingValues } from "../Utils/LayoutHelper";
import { getThematicTrackingInfo } from "./seo";
var TAP_SI = 'valuation_tap_self_inspection';
export var getThematicParams = function getThematicParams(params, config) {
  var seoInformation = getThematicTrackingInfo(params, config);
  var trackingParams = {
    thematic_source: '',
    thematic_keyword: ''
  };
  if (seoInformation && seoInformation.make) {
    trackingParams.thematic_source = 'sell_thematic_make';
    trackingParams.thematic_keyword = seoInformation.make;
  }
  if (seoInformation && seoInformation.location) {
    trackingParams.thematic_source = 'sell_thematic_location';
    trackingParams.thematic_keyword = seoInformation.location;
  }
  return trackingParams;
};
export var trackingHelper = function trackingHelper(_ref) {
  var track = _ref.track,
    browsingMode = _ref.browsingMode,
    locationId = _ref.locationId,
    origin = _ref.origin,
    eventName = _ref.eventName,
    select_from = _ref.select_from,
    redirectedFrom = _ref.redirectedFrom,
    field_name = _ref.field_name,
    landingURLSearch = _ref.landingURLSearch,
    params = _ref.params,
    config = _ref.config,
    chosen_option = _ref.chosen_option,
    _ref$optionalParams = _ref.optionalParams,
    optionalParams = _ref$optionalParams === void 0 ? {} : _ref$optionalParams;
  var _a, _b, _c;
  var ValuationUserDetail = UserSession.getUserEvaluationFormValues();
  var dependencyFunction = DependencyManager.getDependency('functions');
  var trackingInfo = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    user_type: CookieManager.readCookie(REPEAT_USER_COOKIE_NAME) ? USER_VISIT_STATUS.REPEAT : USER_VISIT_STATUS.FIRST_TIME,
    browsing_location_id: locationId || UNKNOWN,
    reason: CookieManager.readCookie(SELLER_STATE_COOKIE) || EVALUATION_STATES.INITIAL,
    browsing_mode: browsingMode || UNKNOWN,
    origin: origin || UNKNOWN,
    select_from: select_from || '',
    flow_type: FLOW_TYPES.NO_DRAFT,
    field_name: field_name || '',
    booking_index_id: LocalStorageHelper.getItem('booking_index_id') || ''
  }, getAcquisitionChannelTrackingValues()), dependencyFunction.getQueryRedirectionParams(landingURLSearch)), {
    redirectedFrom: redirectedFrom || ''
  }), getThematicParams(params || {}, config || {})), optionalParams);
  if (ValuationUserDetail) {
    trackingInfo.item_make = ValuationUserDetail['make-displayValue'];
    trackingInfo.item_model = ValuationUserDetail['model-displayValue'];
    trackingInfo.item_variant = ValuationUserDetail['variant-displayValue'];
    trackingInfo.item_year = ValuationUserDetail['year-displayValue'];
    trackingInfo.item_mileage = ValuationUserDetail['mileage-displayValue'];
    trackingInfo.item_num_owners = ValuationUserDetail['first_owner-displayValue'];
    trackingInfo.item_registeredstate = ValuationUserDetail['registeredState-displayValue'];
    trackingInfo.item_transmission = ValuationUserDetail['transmission-displayValue'];
    trackingInfo.item_bodytype = ValuationUserDetail['bodyType-displayValue'];
    trackingInfo.item_facelift = ValuationUserDetail['faceLift-displayValue'];
    trackingInfo.item_seat = ValuationUserDetail['seat-displayValue'];
    trackingInfo.item_engine = ValuationUserDetail['engine-displayValue'];
    trackingInfo.item_wheeldrive = ValuationUserDetail['wheelDrive-displayValue'];
    trackingInfo.item_sellingurgency = ValuationUserDetail['sellingUrgency-displayValue'];
    trackingInfo.item_fuel_type = (_c = (_b = (_a = ValuationUserDetail['variant-displayValue']) === null || _a === void 0 ? void 0 : _a.match(/Listrik|Hybrid|Bensin|Solar/i)) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.replace(/Solar/i, 'Diesel');
    trackingInfo.phone_number = "+62".concat(ValuationUserDetail['phone-displayValue']);
  }
  var lead_id = LocalStorageHelper.getItem('lead_id');
  if (lead_id) {
    trackingInfo.lead_id = lead_id;
  }
  if (chosen_option) {
    trackingInfo.chosen_option = chosen_option;
  }
  if (track) {
    track(eventName, trackingInfo);
  }
  if (eventName === TAP_SI && dependencyFunction && dependencyFunction.exponeaTrack) {
    dependencyFunction.exponeaTrack('selfInspectionStart');
  }
  return null;
};
export default {
  getThematicParams: getThematicParams
};